import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
const initialState = {
  controllerConfig: null,
  status: "idle",
};

export const fetchControllerConfig = createAsyncThunk(
  "controllerConfig/fetchControllerConfig",
  async ({ controller }, { rejectWithValue }) => {
    try {
      const link = `/${controller}/controller.json`;
      const response = await axios.get(link);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const controllerConfigSlice = createSlice({
  name: "controllerConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchControllerConfig.pending, (state) => {
        state.status = "loading";
        state.controllerConfig = null;
      })
      .addCase(fetchControllerConfig.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.controllerConfig = action?.payload;
      })
      .addCase(fetchControllerConfig.rejected, (state) => {
        state.status = "failed";
      });
  },
});

export default controllerConfigSlice.reducer;
